// Main JavaScript file
console.log('CodeFixr theme loaded');

// Splide Slider Initialization
document.addEventListener('DOMContentLoaded', function() {
    // Initialize Splide sliders
    if (typeof Splide !== 'undefined') {
        // Initialize all recipe sliders
        const recipeSliders = document.querySelectorAll('.recipes-slider .splide, .related-recipes-section .splide');
        
        recipeSliders.forEach(function(slider) {
            const splide = new Splide(slider, {
                type: 'loop',
                perPage: 4,
                perMove: 1,
                gap: '20px',
                pagination: false,
                arrows: true,
                breakpoints: {
                    1200: {
                        perPage: 3,
                    },
                    768: {
                        perPage: 2,
                    },
                    480: {
                        perPage: 1,
                    }
                }
            }).mount();
            
            // Customize the arrow content with your SVG
            addMainSplideArrows(splide);
        });
    }
});

function addMainSplideArrows(splideInstance) {
  const prevArrow = splideInstance.root.querySelector('.splide__arrow--prev');
  const nextArrow = splideInstance.root.querySelector('.splide__arrow--next');
  
  if (prevArrow) {
    prevArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="41" viewBox="0 0 42 41" fill="none"> <g clip-path="url(#clip0_17009_14268)"> <circle cx="20.9995" cy="20.4545" r="20.4545" fill="#0B4970"/> <path d="M21.2695 27.0506L27.6091 20.7345C28.0042 20.3316 28.0135 19.6569 27.6091 19.2539L21.2695 12.9378C20.8839 12.5536 20.2443 12.5349 19.8398 12.891C19.379 13.2846 19.3601 13.9967 19.7834 14.4278L24.3358 18.9634C24.3358 18.9634 14.2057 18.9634 14.1869 18.9634C12.8607 18.9634 12.8325 21.0625 14.1869 21.0625H24.3358L19.7834 25.5981C19.379 26.001 19.379 26.6758 19.7834 27.0787C20.1973 27.463 20.8557 27.463 21.2695 27.0506Z" fill="white" stroke="white" stroke-width="0.490909"/> </g> <defs> <clipPath id="clip0_17009_14268"> <rect x="0.544922" width="40.9091" height="40.9091" rx="20.4545" fill="white"/> </clipPath> </defs> </svg>`;
  }
  
  if (nextArrow) {
    nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="41" viewBox="0 0 42 41" fill="none"> <g clip-path="url(#clip0_17009_14268)"> <circle cx="20.9995" cy="20.4545" r="20.4545" fill="#0B4970"/> <path d="M21.2695 27.0506L27.6091 20.7345C28.0042 20.3316 28.0135 19.6569 27.6091 19.2539L21.2695 12.9378C20.8839 12.5536 20.2443 12.5349 19.8398 12.891C19.379 13.2846 19.3601 13.9967 19.7834 14.4278L24.3358 18.9634C24.3358 18.9634 14.2057 18.9634 14.1869 18.9634C12.8607 18.9634 12.8325 21.0625 14.1869 21.0625H24.3358L19.7834 25.5981C19.379 26.001 19.379 26.6758 19.7834 27.0787C20.1973 27.463 20.8557 27.463 21.2695 27.0506Z" fill="white" stroke="white" stroke-width="0.490909"/> </g> <defs> <clipPath id="clip0_17009_14268"> <rect x="0.544922" width="40.9091" height="40.9091" rx="20.4545" fill="white"/> </clipPath> </defs> </svg>`;
  }
}

// quote Popup Functionality
document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('quote-popup');
    if (!popup) return;

    const closeBtn = popup.querySelector('.quote-popup-close');
    const triggers = document.querySelectorAll('.get-quote-popup');

    // Function to open popup
    function openPopup() {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    // Function to close popup
    function closePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    // Add click event to all triggers
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            openPopup();
        });
    });

    // Close popup when clicking the close button
    closeBtn.addEventListener('click', closePopup);

    // Close popup when clicking outside
    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            closePopup();
        }
    });

    // Close popup when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            closePopup();
        }
    });

});

// Function to handle Mobile Menu
document.addEventListener("DOMContentLoaded", function () {
    const toggleButton = document.querySelector('.humberger-menu');
    const closeButton = document.querySelector('.humberger-menu-close');
    const mobileMenu = document.querySelector('.mobileMenu');
    const header = document.querySelector('.site-header'); // <body>
    const html = document.documentElement; // <html>

    function toggleMobileMenu() {
        mobileMenu.classList.toggle('active');
        header.classList.toggle('header-active');
        html.classList.toggle('menu-active');

    }

    function closeMobileMenu() {
        mobileMenu.classList.remove('active');
        header.classList.remove('header-active');
        html.classList.remove('menu-active');
    }

    toggleButton.addEventListener('click', function () {
        toggleMobileMenu();
    });

    closeButton.addEventListener('click', function () {
        closeMobileMenu();
    });

    // const menuItems = document.querySelectorAll('.mobileMenu a');
    // menuItems.forEach(function (item) {
    //     item.addEventListener('click', function () {
    //         closeMobileMenu();
    //     });
    // });

    window.addEventListener('click', function (event) {
        if (!mobileMenu.contains(event.target) && !toggleButton.contains(event.target)) {
            closeMobileMenu();
        }
    });
});

jQuery(document).ready(function($) {
// Function to handle Footer accordion behavior
function handleAccordion() {
    $('.menu-quick-links-container, .menu-our-services-container, .site-footerInfo, .footer-contactinfo').hide();
    $('.menu-quick-links-container, .menu-our-services-container, .site-footerInfo, .footer-contactinfo').first().slideDown();
    $('#nav_menu-2 .footer-title, #nav_menu-3 .footer-title, #block-3 .footer-title, #block-4 .footer-title').first().addClass('active-legend');

    $('#nav_menu-2 .footer-title, #nav_menu-3 .footer-title, #block-3 .footer-title, #block-4 .footer-title').click(function(){
    $('#nav_menu-2 .footer-title, #nav_menu-3 .footer-title, #block-3 .footer-title, #block-4 .footer-title').not(this).removeClass('active-legend').next('.menu-quick-links-container, .menu-our-services-container, .site-footerInfo, .footer-contactinfo').slideUp();
    $(this).toggleClass('active-legend');
    $(this).next('.menu-quick-links-container, .menu-our-services-container , .site-footerInfo, .footer-contactinfo').slideToggle();
    });
}
// Check window width and execute accordion behavior only for small screens
if ($(window).width() < 768) {
    handleAccordion();
}  

// hide #back-top first
$("#back-top").hide();

// fade in #back-top on scroll
$(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
        $('#back-top').fadeIn();
    } else {
        $('#back-top').fadeOut();
    }
});

// scroll to top on click
$('#back-top a').click(function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 800);
});

$("#order_review_heading").appendTo("#order_review");
// Custom coupon toggle for your modified template
$('.showcoupon-2').on('click', function (e) {
  e.preventDefault();
  $('.woocommerce-form-coupon-2').slideToggle(400, function () {
      $('.showcoupon-2').attr('aria-expanded', $('.woocommerce-form-coupon-2').is(':visible'));
  });
  return false;
});
});


// Function to setup quantity buttons
function setupQuantityButtons() {
  const qtyInputs = document.querySelectorAll(".quantity input.qty");
  
  qtyInputs.forEach(function(qtyInput) {
    // Check if buttons already exist for this input
    if (qtyInput.previousElementSibling && qtyInput.previousElementSibling.classList.contains('qty-minus')) {
      return; // Buttons already exist
    }
    
    // Create buttons
    qtyInput.insertAdjacentHTML("beforebegin", '<button type="button" class="qty-minus"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <path d="M16 10H2V8H16V10Z" fill="#1C1D1F"/> </svg></button>');
    qtyInput.insertAdjacentHTML("afterend", '<button type="button" class="qty-plus"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"> <path d="M16 10H2V8H16V10Z" fill="#1C1D1F"/> <path d="M10 2V16H8V2H10Z" fill="#1C1D1F"/> </svg></button>');

    // Add event listeners
    const minusBtn = qtyInput.previousElementSibling;
    const plusBtn = qtyInput.nextElementSibling;
    
    minusBtn.onclick = () => {
      qtyInput.value = Math.max(1, +qtyInput.value - 1);
      // Trigger multiple events to ensure WooCommerce detects the change
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('keyup', { bubbles: true }));
      
      // If we're on the cart page, trigger the update cart button
      if (document.querySelector('.woocommerce-cart-form')) {
        const updateCartBtn = document.querySelector('button[name="update_cart"]');
        if (updateCartBtn) {
          updateCartBtn.removeAttribute('disabled');
          updateCartBtn.classList.remove('disabled');
        }
      }
    };
    
    plusBtn.onclick = () => {
      qtyInput.value = +qtyInput.value + 1;
      // Trigger multiple events to ensure WooCommerce detects the change
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('keyup', { bubbles: true }));
      
      // If we're on the cart page, trigger the update cart button
      if (document.querySelector('.woocommerce-cart-form')) {
        const updateCartBtn = document.querySelector('button[name="update_cart"]');
        if (updateCartBtn) {
          updateCartBtn.removeAttribute('disabled');
          updateCartBtn.classList.remove('disabled');
        }
      }
    };
  });
}

// Setup quantity buttons on page load
document.addEventListener("DOMContentLoaded", setupQuantityButtons);

// Setup quantity buttons for dynamically loaded content (like quick view)
document.addEventListener("DOMContentLoaded", function() {
  // Listen for YITH Quick View content to be loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any added nodes contain quantity inputs
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.querySelector('.quantity input.qty') || node.classList.contains('quantity'))) {
            setupQuantityButtons();
          }
        });
      }
    });
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also listen for YITH Quick View specific events
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('yith_wcqv_ajax_success', function() {
      // Add a small delay to ensure DOM is fully ready
      setTimeout(setupQuantityButtons, 100);
    });
  }
  
  // Special handling for cart page
  if (document.querySelector('.woocommerce-cart-form')) {
    // Enable update cart button when quantity changes
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('qty')) {
        const updateCartBtn = document.querySelector('button[name="update_cart"]');
        if (updateCartBtn) {
          updateCartBtn.removeAttribute('disabled');
          updateCartBtn.classList.remove('disabled');
        }
      }
    });
    
    // Also listen for input events
    document.addEventListener('input', function(e) {
      if (e.target.classList.contains('qty')) {
        const updateCartBtn = document.querySelector('button[name="update_cart"]');
        if (updateCartBtn) {
          updateCartBtn.removeAttribute('disabled');
          updateCartBtn.classList.remove('disabled');
        }
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".dgwt-wcas-search-wrapp");
    if (!wrapper) return;

    const submitBtn = wrapper.querySelector(".dgwt-wcas-search-submit");
    if (!submitBtn) return;

    submitBtn.addEventListener("click", function () {
        wrapper.classList.add("dgwt-wcas-search-focused");
    });
});

// Initialize for dynamically loaded content
if (typeof jQuery !== 'undefined') {
    jQuery(document).on('DOMNodeInserted', function(e) {
        if (e.target.classList && e.target.classList.contains('custom-ajax-search')) {
            initCustomAjaxSearch();
        }
    });
}
// Showing Placeholder image in Recent Post Widget
document.addEventListener('DOMContentLoaded', function () {
    const placeholder = '/wp-content/uploads/2025/10/placeholder.jpg';

    document.querySelectorAll('.uagb-post__inner-wrap').forEach(post => {
        // Check if image div exists
        let imageDiv = post.querySelector('.uagb-post__image');

        // Get post link from title (always exists)
        const titleLink = post.querySelector('.uagb-post__title a');
        const postLink = titleLink ? titleLink.getAttribute('href') : '#';

        // If .uagb-post__image doesn't exist, create and insert it before the wrapper
        if (!imageDiv) {
            const newImageDiv = document.createElement('div');
            newImageDiv.classList.add('uagb-post__image');
            newImageDiv.innerHTML = `
                <a href="${postLink}" target="_self" rel="bookmark noopener noreferrer" class="uagb-image-ratio-inherit">
                    <img src="${placeholder}" alt="Placeholder" loading="lazy" decoding="async">
                </a>
            `;
            post.insertBefore(newImageDiv, post.querySelector('.uag-post-grid-wrapper'));
        }
    });
});


// Converting Logo Carousel into Load More at below 600px

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".swiper-wrapper");
  const slides = Array.from(document.querySelectorAll(".swiper-slide"))
    .filter(slide => !slide.classList.contains("swiper-slide-duplicate")); // exclude duplicates ✅

  if (window.innerWidth <= 600 && slides.length > 4) {

    // Stop swiper transform
    wrapper.style.transform = "none";

    // Hide all slides initially
    slides.forEach(slide => slide.style.display = "none");

    // Show first 4 slides
    slides.slice(0, 4).forEach(slide => slide.style.display = "block");

    // Create Load More Button with icon
    const loadMoreBtn = document.createElement("button");
    loadMoreBtn.id = "loadMoreSlides";
    loadMoreBtn.innerHTML = `
      Load More
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none" style="margin-left:6px;">
        <path d="M5.38337 0L4.53746 0.858347L7.52822 3.89305L0 3.89305L0 5.10694H7.52822L4.53746 8.14166L5.38337 9L9.81818 4.49999L5.38337 0Z" fill="#113B78"/>
      </svg>
    `;

    wrapper.after(loadMoreBtn);

    loadMoreBtn.addEventListener("click", function () {
      // Show all remaining real slides (no duplicates)
      slides.forEach(slide => slide.style.display = "block");
      loadMoreBtn.style.display = "none";
    });
  }
});

// Smooth scroll with offset for anchor links
(function() {
  const scrollOffset = 120; // Adjust this value as needed (in pixels)

  function scrollToAnchor(hash, offset = scrollOffset) {
    if (!hash) return;
    
    const targetId = hash.replace('#', '');
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  // Handle click events on anchor links
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (href === '#' || href === '#!') return;
    
    e.preventDefault();
    scrollToAnchor(href, scrollOffset);
  });

  // Handle direct hash navigation (when page loads with hash)
  function handleHashOnLoad() {
    if (window.location.hash) {
      // Small delay to ensure page is fully rendered
      setTimeout(() => {
        scrollToAnchor(window.location.hash, scrollOffset);
      }, 100);
    }
  }

  // Handle hash change (when hash changes without page reload)
  window.addEventListener('hashchange', function() {
    scrollToAnchor(window.location.hash, scrollOffset);
  });

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashOnLoad);
  } else {
    handleHashOnLoad();
  }
})();